import one from '../assets/svg/projects/one.svg'
import two from '../assets/svg/projects/two.svg'
import three from '../assets/svg/projects/three.svg'
import four from '../assets/svg/projects/four.svg'
import five from '../assets/svg/projects/five.svg'
import six from '../assets/svg/projects/six.svg'

export const projectsData = [
  {
    id: 1,
    projectName: 'AI-Powered PDF Assistant',
    projectDesc: 'Full-stack app to upload PDFs and ask natural language questions. Uses LangChain + FAISS vector search for context-aware answers with page citations, FastAPI backend, and React frontend. Dockerized for one-command deploy.',
    tags: ['FastAPI', 'React', 'LangChain', 'Docker'],
    code: 'https://github.com/kish-00/ai-pdf-assistant',
    demo: 'https://ai-pdf-assistant.netlify.app',
    image: five
  },
  {
    id: 2,
    projectName: "Founder's Operational Dashboard",
    projectDesc: 'Real-time executive dashboard with React + TypeScript frontend, FastAPI backend, and PostgreSQL. Tracks sales pipeline, tasks, email campaigns, and revenue with interactive Recharts visualizations.',
    tags: ['React', 'TypeScript', 'FastAPI', 'PostgreSQL'],
    code: 'https://github.com/kish-00/founders-dashboard',
    demo: 'https://kish-founders-dashboard.netlify.app',
    image: six
  },
  {
    id: 3,
    projectName: 'Founder Inbox Cleaner',
    projectDesc: 'An n8n workflow that classifies incoming emails by priority (using ChatGPT) and auto-labels/archives low-priority messages.',
    tags: ['n8n', 'Gmail API', 'ChatGPT'],
    code: 'https://github.com/kish-00/founder-inbox-cleaner',
    demo: '',
    image: one
  },
  {
    id: 4,
    projectName: 'Meeting Note Summarizer',
    projectDesc: 'A webhook-triggered automation that summarizes meeting transcripts using ChatGPT and saves them to a Notion database.',
    tags: ['n8n', 'OpenAI', 'Notion API'],
    code: 'https://github.com/kish-00/meeting-note-summarizer',
    demo: '',
    image: two
  },
  {
    id: 5,
    projectName: 'Content Scheduler',
    projectDesc: 'An n8n workflow that auto-posts Canva designs to Twitter and LinkedIn on a schedule using AI-generated captions.',
    tags: ['n8n', 'Canva API', 'OpenAI', 'Social Media'],
    code: 'https://github.com/kish-00/content-scheduler',
    demo: '',
    image: three
  },
  {
    id: 6,
    projectName: 'Graph Theory Visualizer',
    projectDesc: 'An open-source tool to visualize graph operations: BFS, DFS, Kruskal, and Dijkstra algorithms.',
    tags: ['TypeScript', 'JavaScript', 'Algorithms'],
    code: 'https://github.com/kish-00/graph-theory_visualizer',
    demo: 'https://kish-00.github.io/graph-theory_visualizer/',
    image: four
  },
]
